/** The exact-path redirects from `middleware.page.ts`, in its order. */
export const PATH_REDIRECTS: ReadonlyMap<string, string> = new Map([
  ["/", "/dashboard"],
  ["/profile/profile", "/profile"],
  ["/proxy", "/dashboard"],
  ["/proxy/list", "/dashboard"],
  ["/userapi", "/userapi/keys"],
]);
